import {
  CATALOG_AUTHOR_LIST_SET_DATA,
  CATALOG_AUTHOR_LIST_RESET_DATA,
} from 'rebook/apps/catalog/constants';


const initialState = {
  list: null,
  paginateBy: 16,
  pageNumber: 1,
  lastPageNumber: 0,
  orderBy: 'weight',
  totalAuthorsCount: null,
};

const authorList = (state = initialState, action) => {
  switch (action.type) {
    case CATALOG_AUTHOR_LIST_SET_DATA:
      return {
        ...state,
        ...action.payload,
      };
    case CATALOG_AUTHOR_LIST_RESET_DATA:
      return initialState;
    default:
      return state;
  }
};

export default authorList;
